(() => {
	const initAnnouncementSlider = () => {
		const announcementSliders = document.querySelectorAll(".announcement-bar__swiper");
		
		announcementSliders.forEach((slider) => {
			const autoplay = slider.getAttribute("data-autoplay") === "true";
			const speed = parseInt(slider.getAttribute("data-speed")) || 5000;
			
			const announcementSwiper = new Swiper(slider, {
				direction: 'horizontal',
				loop: true,
				autoplay: autoplay ? {
					delay: speed,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				} : false,
				speed: 500,
				effect: 'slide',
				slidesPerView: 1,
				spaceBetween: 0,
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				watchSlidesProgress: true,
				preventInteractionOnTransition: true
			});
			
			// Pause on hover if autoplay is enabled
			if (autoplay) {
				slider.addEventListener("mouseenter", () => {
					announcementSwiper.autoplay.stop();
				});
				slider.addEventListener("mouseleave", () => {
					announcementSwiper.autoplay.start();
				});
			}
		});
	};
	
	// Initialize on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAnnouncementSlider);
	} else {
		initAnnouncementSlider();
	}
	
	// Re-initialize when section is loaded in theme editor
	document.addEventListener("shopify:section:load", function (event) {
		if (event.detail.sectionId && document.querySelector(".announcement-bar__swiper")) {
			initAnnouncementSlider();
		}
	});
})();

